export enum TimeOffReason {
  LUNCH_BREAK = 'lunch_break',
  TOILET_BREAK = 'toilet_break',
  URGENT_CALL = 'urgent_call',
  PRAY = 'pray',
}
